module.exports = __webpack_public_path__ + "img/filter-welcome-background-lincoln.2101fab1.png";